import dkFlag from '../assets/DK.png';
import noFlag from '../assets/NO.png';
import usFlag from '../assets/US.png';
import seFlag from '../assets/SE.png';

export const allBookingSystems = [
    {
        name: 'Link DK',
        flagUrl: dkFlag,
        bookingSystemKey: 'YOYODenmark'
    },
    {
        name: 'Link NO',
        flagUrl: noFlag,
        bookingSystemKey: 'YOYONorway'
    },
    {
        name: 'Link US',
        flagUrl: usFlag,
        bookingSystemKey: 'YOYOUnitedStates'
    },
    {
        name: "Link SE",
        flagUrl: seFlag,
        bookingSystemKey: 'YOYOSweden'
    }
];

export const allLanguages = [
    {
        LocalName: 'English',
        GlobalName: 'English',
        LanguageKey: 'en'
    },
    {
        LocalName: 'Dansk',
        GlobalName: 'Danish',
        LanguageKey: 'da'
    },
    {
        LocalName: 'Norsk',
        GlobalName: 'Norwegian',
        LanguageKey: 'no'
    },
    {
        LocalName: 'Svensk',
        GlobalName: 'Swedish',
        LanguageKey: 'se'
    }
];
